import React, { Component } from 'react';
import './Game_UserStats.css';
import GameAPI from './GameAPI';

const DEFAULT_ATTACKS_PER_MINUTE = 6;
const MIN_ATTACKS_PER_MINUTE = 1;
const MAX_ATTACKS_PER_MINUTE = 240;

function normalizeStatName(name) {
    return String(name || '').toLowerCase().replace(/[^a-z0-9]/g, '');
}

function getStatRange(value) {
    const from = Number(value?.valueFrom);
    const to = Number(value?.valueTo);
    const safeFrom = Number.isFinite(from) ? from : 0;
    const safeTo = Number.isFinite(to) ? to : safeFrom;
    return { from: safeFrom, to: safeTo };
}

function formatNumber(value, precision = 1) {
    return Number(value.toFixed(precision)).toString();
}

function formatRange(from, to, precision = 1) {
    const fromDisplay = formatNumber(from, precision);
    const toDisplay = formatNumber(to, precision);
    return from === to ? fromDisplay : `${fromDisplay} - ${toDisplay}`;
}

function findStat(stats, normalizedName) {
    const key = Object.keys(stats || {}).find(name => normalizeStatName(name) === normalizedName);
    return key ? stats[key] : null;
}

function formatStatName(name) {
    const normalizedName = normalizeStatName(name);
    if (normalizedName === 'weaponattackspeed') return 'Attack Speed';
    if (normalizedName === 'magicfind') return 'Magic Find';
    return name;
}

export function getEffectiveAttacksPerMinute(stats) {
    const attackSpeed = findStat(stats, 'weaponattackspeed');
    const { to } = getStatRange(attackSpeed);
    const attacksPerMinute = attackSpeed ? to : DEFAULT_ATTACKS_PER_MINUTE;
    return Math.min(MAX_ATTACKS_PER_MINUTE, Math.max(MIN_ATTACKS_PER_MINUTE, attacksPerMinute));
}

export function formatAttackCadence(attacksPerMinute) {
    const attacksPerSecond = attacksPerMinute / 60;
    if (attacksPerSecond >= 1) {
        const label = attacksPerSecond === 1 ? 'attack' : 'attacks';
        return `${formatNumber(attacksPerSecond, 2)} ${label}/s`;
    }

    return `1 attack every ${formatNumber(60 / attacksPerMinute, 2)}s`;
}

function formatStatValue(name, value, stats) {
    const { from, to } = getStatRange(value);
    const normalizedName = normalizeStatName(name);
    const attacksPerMinute = getEffectiveAttacksPerMinute(stats);

    if (normalizedName === 'damage') {
        const attacksPerSecond = attacksPerMinute / 60;
        const damage = formatRange(from, to);
        const dps = formatRange(from * attacksPerSecond, to * attacksPerSecond, 2);
        return `${damage} (${dps} DPS)`;
    }

    if (normalizedName === 'weaponattackspeed') {
        return `${formatNumber(attacksPerMinute, 2)} APM · ${formatAttackCadence(attacksPerMinute)}`;
    }

    if (normalizedName === 'magicfind') {
        return `${formatRange(from, to, 2)} MF`;
    }

    return formatRange(from, to);
}



export class GameUserStats extends Component {


    constructor(props) {
        super(props);
        this.state = {
            stats: {}
        }


    }

    componentDidMount() {
        this.isMountedFlag = true;
        this.loadStats(this.props.stats);
    }

    componentWillUnmount() {
        this.isMountedFlag = false;
    }

    componentDidUpdate(prevProps) {
        if (this.props.stats !== prevProps.stats) {
            this.loadStats(this.props.stats);
        }
    }

    loadStats = async (sourceStats) => {
        const stats = {};
        for (const key in sourceStats) {
            if (key && key.length === 24) {
                const stat = await GameAPI.fetchStat(key);
                if (stat?.name) {
                    stats[stat.name] = sourceStats[key];
                }
            } else {
                stats[key] = sourceStats[key];
            }
        }
        if (!findStat(stats, 'weaponattackspeed')) {
            stats.weaponAttackSpeed = {
                valueFrom: DEFAULT_ATTACKS_PER_MINUTE,
                valueTo: DEFAULT_ATTACKS_PER_MINUTE
            };
        }
        if (this.isMountedFlag && this.props.stats === sourceStats) {
            this.setState({ stats });
        }
    };




    render() {
        const { stats } = this.state;
        return (
            <dl className="game-stats">
                {stats && Object.keys(stats)?.map((key) => {
                    const value = stats[key];
                    return (
                        <div className="game-stats__row" key={key}>
                            <dt className="game-stats__name">
                                {formatStatName(key)}
                            </dt>
                            <dd className="game-stats__value">
                                {formatStatValue(key, value, stats)}
                            </dd>
                        </div>
                    );
                })
                }
            </dl>



        );
    }

}
